import {captureException} from "../errorHelper";

/**
 * Used in an axios promise .catch() method to handle response errors without suppressing syntax/JS errors.
 */
export function axiosCatchHandler(error, callback) {
  const {response} = error;

  /**
   * The total absence of a response indicates that the .catch() has picked up a JS error from earlier in the
   * promise chain. We should report that to Sentry, without this - it would be suppressed.
   */
  if (response === undefined || !response) {
    captureException(error);
    return;
  }

  /**
   * If we reach this point, the error var is the server response.
   * Pass that to the callback provided.
   */
  if (callback) {
    callback(error);
    return;
  }

  /**
   * Assuming there is no callback, throw the error onward to be picked up by the next catch block.
   */
  throw error;
}

/**
 * Setting session variables for data-persistence in VueX modules.
 */
export function writeSession(moduleNamespace, field, value) {
  window.sessionStorage.setItem(`${moduleNamespace}_${field}`, value);
}

/**
 * Retrieve an item from session, for use in VueX modules.
 */
export function getItemFromSession(moduleNamespace, field) {
  return window.sessionStorage.getItem(`${moduleNamespace}_${field}`);
}

/**
 * Retrieve a JSON encoded object from session, for use in VueX modules.
 */
export function getObjectFromSession(moduleNamespace, field) {
  const object = JSON.parse(window.sessionStorage.getItem(`${moduleNamespace}_${field}`));
  return object === null ? null : object;
}

/**
 * Format an integer to a properly formatted price string for display to users.
 */
// TODO: Replace with Intl.format (or whatever it is)
export function formatPriceInput(input) {
  if (input === '0' || !input || isNaN(input)) {
    return '0.00';
  }

  // If we're modifying a price field, ensure NaN/undefined is set as 0.
  if (input.includes('.')) {
    return parseFloat(input)
      .toFixed(2)
      .toLocaleString('en-GB', {
        minimumFractionDigits: 2,
      });
  }

  return`${input}.00`;
}
